import { render, staticRenderFns } from "./ActionInsight.vue?vue&type=template&id=f71632ca&scoped=true"
import script from "./ActionInsight.vue?vue&type=script&lang=ts"
export * from "./ActionInsight.vue?vue&type=script&lang=ts"
import style0 from "./ActionInsight.vue?vue&type=style&index=0&id=f71632ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.26.0__cache-loader@4.1.0_webpack@4_duly6tfyc62fvcli236pnhbyri/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f71632ca",
  null
  
)

export default component.exports